import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useReducedMotion } from '../../../theme/hooks.js';
import type { IconProps } from '../../primitives/types.js';

/** User avatar silhouette with a calm presence halo.
 *  The halo uses opposite-phase radius + opacity animations so it feels
 *  like a soft breath rather than a blinking signal. */
export function IcnUser(props: IconProps): ReactNode {
  const reduced = useReducedMotion();
  return (
    <Svg {...props} iconName="user">
      {!reduced && (
        <circle cx="8" cy="8" r="6.5" opacity="0.14" fill="currentColor" stroke="none">
          <animate attributeName="r" values="6.2;7.4;6.2" dur="3.2s" repeatCount="indefinite" />
          <animate
            attributeName="opacity"
            values="0.18;0.06;0.18"
            dur="3.2s"
            repeatCount="indefinite"
          />
        </circle>
      )}
      <circle cx="8" cy="6" r="2.4" />
      <path d="M3 13c0-2.4 2.2-4 5-4s5 1.6 5 4" />
    </Svg>
  );
}
